export enum WoningtypeEnum {
  EENGEZINS = 'Eengezins',
  MEERGEZINS = 'Meergezins',
  ONBEKEND = 'Onbekend',
}
